<template><div style="height: calc(100% - 120px);margin-top: 200px;">
    <input v-model="input" style="border: solid 1px #000000;font-size: 20px;">
    <div style="font-size: 25px;color:#FF391D">乘结果：{{result}}</div>
  <input v-model="input1" style="border: solid 1px #000000;font-size: 20px;">
  <div style="font-size: 25px;color:#FF391D">除结果：{{result_chu}}</div>


  </div>

</template>

<script>

export default {

  data() {
    return{
      input:0,
      input1:1,
      cheng:6.25,
      chu:16,

    }
  },
  created() {

  },

  computed:{
    result() {
          let r=this.input*this.cheng
          return r
      },
    result_chu(){
      let c=this.input1/this.chu
      return c
    }
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
//手机端样式
@media screen and (max-width: 800px) and (min-width: 10px){
  //::v-deep .vtabs{
  //  .v-input .v-label {
  //    height: 0.2rem;
  //    line-height: 0.2rem;
  //    letter-spacing: normal;
  //  }
  //  // border-radius: 4px;
  //  // background: #3A3A3A;
  //  padding: 0.1rem;
  //  height: 40%;
  //  & .v-tabs {
  //    width: unset;
  //  }
  //  & .v-tab {
  //    // width: 100px;
  //    // height: 22px;
  //    font-size: 0.16rem;
  //    font-family: PingFangSC-Regular, PingFang SC;
  //    font-weight: 400;
  //    color: #3A3A3A;
  //    line-height: 0.22rem;
  //  }
  //  // & .v-tabs-bar{
  //  //     width: 30%;
  //  // }
  //  & .v-tabs--grow > .v-tabs-bar .v-tab{
  //    flex: unset !important;
  //  }
  //  & .v-slide-group__content,
  //  & .v-slide-group__wrapper{
  //    flex: unset !important;
  //  }
  //  & .v-tabs-slider{
  //    width: 80%;
  //    margin-left: 10%;
  //  }
  //  & .v-text-field > .v-input__control > .v-input__slot:before,
  //  & .v-text-field > .v-input__control > .v-input__slot:after{
  //    border-style: unset;
  //  }
  //  & textarea{
  //    // height: 100% !important;
  //    min-height: 2.24rem;
  //    max-height: 2.24rem;
  //    margin: 0 0.20rem;
  //  }
  //  & .v-counter{
  //    margin-right: 0.20rem;
  //  }
  //  & label{
  //    font-size: 0.14rem;
  //  }
  //  & .theme--light.v-tabs-items{
  //    background-color: unset;
  //    height: 100%;
  //  }
  //  & .v-window-item .searchField{
  //    display: flex;
  //    justify-content: center;
  //    width: 2.96rem;
  //    height:0.96rem
  //  }
  //  & .v-window-item {
  //    display: flex;
  //    align-items: center;
  //    justify-content: center;
  //    flex-direction: column;
  //  }
  //  & .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot{
  //    min-height:0.44rem;
  //  }
  //  & .v-text-field--outlined .v-label{
  //    top: 0.12rem;
  //  }
  //  & .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer{
  //    margin-top: 0.10rem;
  //  }
  //}
  //::v-deep .ant-list-split .ant-list-item{
  //  border-bottom:unset;
  //}
  //::v-deep .v-application ul, .v-application ol{
  //  padding-left:0.8rem;
  //}
  .searchPanel{
    width:3.48rem;
    min-height:3.5rem;
    height:auto;
    background: #F5F5F6;
    border-radius: 0.32rem 0.32rem 0rem 0rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0.22rem;
  }
  .topBanner{
    width: 100%;
    height:auto;
    text-align: center;
    border-bottom:solid 1px #cccccc;
    padding: 0.1rem;
  }
  .topTitle {
    width: 100%;
    height: 0.58rem;
    line-height: 0.58rem;
    font-size: 0.2rem;
    font-weight: 600;
    color: #3A3A3A;
    text-align: center;
    margin-top: 0.08rem;
  }
  .topTip{
    width: 100%;
    height: 0.15rem;
    line-height: 0.15rem;
    font-size: 0.1rem;
    color: #4d4d4d;
    text-align: center
  }
  .computerStyle {
    display: none;
  }
  .phoneStyle {
  }
}
@media screen and (min-width: 800px) {
  .computerStyle {
    .topTips{
      position: relative;
      top: 76px;
      width: 100%;
      height: 76px;
      background: #F5F5F6;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      div{
        width: 532px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A3A3A;
        line-height: 20px;
        text-align: center;
      }
    }
    .queryDiv{
      position: relative;
      top: 76px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .title{
        // width: 330px;
        height: 42px;
        font-size: 30px !important;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3A3A3A;
        line-height: 42px;
        margin: 50px 0;
      }
      .mainPanel{
        width: 1280px;
        height: 480px;
        display: flex;

        .mapPanel{
          width: 640px;
          border-radius: 32px 0px 0px 32px;

        }
        .detailPanel{
          width: 640px;
          border-radius: 0px 32px 32px 0px;
          background: #F7F7F7;
          .priceResultList{
            position: absolute;
            width: 565px;
            margin: -60px 0 0 33px;
            background: #F7F7F7;



          }
          .detail{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin: 30px 0 0 22px;

            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #979797;
            line-height: 20px;
            span{
              color: #3A3A3A;
              margin-left: 10px;
            }

            .left{
              div{
                height: 30px;
                .rmb{
                  color: #3A3A3A;
                }
                .price{
                  color: #FF4040;
                  font-size: 20px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 500;
                  margin-left: unset;
                }
              }
            }
            .right{
              margin-left: 30px;
              div{
                height: 30px;
                .rmb{
                  color: #3A3A3A;
                }
                .price{
                  color: #FF4040;
                  font-size: 20px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 500;
                  margin-left: unset;
                }
              }
            }
          }
        }
      }
    }
    ::v-deep .vtabs{
        // border-radius: 4px;
        // background: #3A3A3A;
        padding: 10px;
        height: 40%;
        & .v-tabs {
          width: unset;
        }
        & .v-tab {
          // width: 100px;
          // height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3A3A3A;
          line-height: 22px;
        }
        // & .v-tabs-bar{
        //     width: 30%;
        // }
        & .v-tabs--grow > .v-tabs-bar .v-tab{
          flex: unset !important;
        }
        & .v-slide-group__content,
        & .v-slide-group__wrapper{
          flex: unset !important;
        }
        & .v-tabs-slider{
            width: 80%;
            margin-left: 10%;
        }
        & .v-text-field > .v-input__control > .v-input__slot:before,
        & .v-text-field > .v-input__control > .v-input__slot:after{
            border-style: unset;
        }
        & textarea{
            // height: 100% !important;
            min-height: 224px;
            max-height: 224px;
            margin: 0 20px;
        }
        & .v-counter{
            margin-right: 20px;
        }
        & label{
            font-size: 14px;
        }
        & .theme--light.v-tabs-items{
          background-color: unset;
          height: 100%;
        }
        & .v-window-item .searchField{
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

        }
        & .v-window-item {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        }
        & .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot{
          min-height:44px;
        }
        & .v-text-field--outlined .v-label{
          top: 12px;
        }
        & .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer{
          margin-top: 10px;
        }
    }
    ::v-deep .ant-list-split .ant-list-item{
      border-bottom:unset;
    }
    ::v-deep .v-application ul, .v-application ol{
      padding-left:8px;
    }
  }
  .phoneStyle{
    display: none;
  }
}

</style>